export const getClusterIdFromPathname = (pathname: string): string | null => {
    const match = pathname.match(/\/cluster\/([^/]+)/);
    return match?.[1] ?? null;
};

export const shouldHoldClusterPanelUntilReady = (
    pathname: string,
    panelType: string | null | undefined,
    loadedClusterId: string | undefined
): boolean => {
    if (!panelType) {
        return false;
    }
    const clusterIdFromPath = getClusterIdFromPathname(pathname);
    if (!clusterIdFromPath) {
        return false;
    }
    return loadedClusterId !== clusterIdFromPath;
};

export const shouldHoldPanelOpen = (options: {
    pathname: string;
    panelType: string | null | undefined;
    loadedClusterId?: string;
    translationsReady: boolean;
    deferPanelFromUrl?: boolean;
}): boolean => {
    if (!options.panelType) {
        return false;
    }
    if (!options.translationsReady) {
        return true;
    }
    if (options.deferPanelFromUrl) {
        return true;
    }
    return shouldHoldClusterPanelUntilReady(
        options.pathname,
        options.panelType,
        options.loadedClusterId
    );
};
